module.exports = __webpack_public_path__ + "img/pin-check-adress.6f1cd3d1.svg";